import { render, staticRenderFns } from "./GroupUserComponent.vue?vue&type=template&id=dc93277c"
import script from "./GroupUserComponent.vue?vue&type=script&lang=js"
export * from "./GroupUserComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports